{
  "AGENT_MGMT": {
    "HEADER": "Agenter",
    "HEADER_BTN_TXT": "Legg til agent",
    "LOADING": "Henter agentliste",
    "DESCRIPTION": "En agent er et medlem av kundestøtteteamet som kan se og svare på brukermeldinger. Listen nedenfor viser alle agenter på kontoen din.",
    "LEARN_MORE": "Lær om brukerroller",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "Det er ingen agenter tilknyttet denne kontoen",
      "TITLE": "Administrer agentene i ditt team",
      "DESC": "Du kan legge til eller fjerne agenter i ditt team.",
      "NAME": "Navn",
      "EMAIL": "E-POST",
      "STATUS": "Satus",
      "ACTIONS": "Handlinger",
      "VERIFIED": "Verifisert",
      "VERIFICATION_PENDING": "Verifisering venter",
      "AVAILABLE_CUSTOM_ROLE": "Tilgjengelige egendefinerte rolletillatelser"
    },
    "ADD": {
      "TITLE": "Legg til agent i teamet ditt",
      "DESC": "Du kan legge til personer som vil kunne håndtere støtte for dine innbokser.",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "FORM": {
        "NAME": {
          "LABEL": "Agent navn",
          "PLACEHOLDER": "Skriv inn navnet til agenten"
        },
        "AGENT_TYPE": {
          "LABEL": "Rolle",
          "PLACEHOLDER": "Velg en rolle",
          "ERROR": "En rolle er påkrevd"
        },
        "EMAIL": {
          "LABEL": "E-postadresse",
          "PLACEHOLDER": "Skriv inn en agent sin e-postadresse"
        },
        "SUBMIT": "Legg til agent"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent ble lagt til",
        "EXIST_MESSAGE": "E-postadressen til agenten er allerede i bruk, prøv en annen e-postadresse",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slett",
      "API": {
        "SUCCESS_MESSAGE": "Agenten ble slettet",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      },
      "CONFIRM": {
        "TITLE": "Bekreft sletting",
        "MESSAGE": "Er du sikker på at du vil slette ",
        "YES": "Ja, slett ",
        "NO": "Nei, behold "
      }
    },
    "EDIT": {
      "TITLE": "Rediger agent",
      "FORM": {
        "NAME": {
          "LABEL": "Agent navn",
          "PLACEHOLDER": "Skriv inn navnet til agenten"
        },
        "AGENT_TYPE": {
          "LABEL": "Rolle",
          "PLACEHOLDER": "Velg en rolle",
          "ERROR": "En rolle er påkrevd"
        },
        "EMAIL": {
          "LABEL": "E-postadresse",
          "PLACEHOLDER": "Skriv inn en agent sin e-postadresse"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Tilgjengelighet",
          "PLACEHOLDER": "Vennligst velg en tilgjengelighet status",
          "ERROR": "Tilgjengelighet er påkrevd"
        },
        "SUBMIT": "Rediger agent"
      },
      "BUTTON_TEXT": "Rediger",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Agenten ble oppdatert",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Tilbakestill passord",
        "ADMIN_SUCCESS_MESSAGE": "En e-post med instruksjoner for å tilbakestille passordet er sendt til agenten",
        "SUCCESS_MESSAGE": "Passordet til agenten ble tilbakestilt",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      }
    },
    "SEARCH_PLACEHOLDER": "Søk etter agenter...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "Ingen resultater funnet."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Ingen",
      "TITLE": {
        "AGENT": "Velg agent",
        "TEAM": "Velg gruppe"
      },
      "LIST": {
        "NONE": "Ingen"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Ingen agenter funnet",
          "TEAM": "Ingen grupper funnet"
        },
        "PLACEHOLDER": {
          "AGENT": "Søk etter agenter",
          "TEAM": "Søk blant grupper",
          "INPUT": "Søk etter agenter"
        }
      }
    }
  }
}
